import type { LandingPage } from '../types';
import { v4 as uuidv4 } from 'uuid';

const STORAGE_KEY = 'all_in_one_landing_page';

export function getLandingPage(workspaceId: string): LandingPage {
  const stored = localStorage.getItem(`${STORAGE_KEY}_${workspaceId}`);
  if (stored) {
    const data = JSON.parse(stored);
    return {
      ...data,
      createdAt: new Date(data.createdAt),
      updatedAt: new Date(data.updatedAt),
    };
  }

  // Create default from scratch if none exists
  const now = new Date();
  const defaultPage: LandingPage = {
    id: uuidv4(),
    workspaceId,
    createdAt: now,
    updatedAt: now,
    title: 'Modern Business Solutions',
    heroSubtitle: 'Transforming your daily operations with AI-driven efficiency.',
    heroCtaText: 'Get Started',
    heroCtaUrl: '/onboarding',
    primaryColor: '#0ea5e9', // sky-500
    accentColor: '#8b5cf6',  // violet-500
    features: [
      { id: '1', icon: '⚡', title: 'Fast Setup', description: 'Get up and running in minutes with our AI orchestration.' },
      { id: '2', icon: '🛠️', title: 'Modular Domain', description: 'Pick only the modules you need for your business.' },
      { id: '3', icon: '📊', title: 'Deep Insights', description: 'Understand your business trends with automated analytics.' },
    ],
    sections: [],
    isPublished: false,
  };

  saveLandingPage(defaultPage);
  return defaultPage;
}

export function saveLandingPage(page: LandingPage): void {
  const data = {
    ...page,
    updatedAt: new Date(),
  };
  localStorage.setItem(`${STORAGE_KEY}_${page.workspaceId}`, JSON.stringify(data));
}

export function updateLandingPage(workspaceId: string, updates: Partial<LandingPage>): LandingPage {
  const current = getLandingPage(workspaceId);
  const updated = { ...current, ...updates };
  saveLandingPage(updated);
  return updated;
}
